"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleForemanWirePhaseHeightFieldJoin = void 0;
var tslib_1 = require("tslib");
var field_join_ikecalc_1 = require("./field.join.ikecalc");
var WIRE_PHASE_HEIGHTS = ['phaseAHeight', 'phaseBHeight', 'phaseCHeight'];
var PoleForemanWirePhaseHeightFieldJoin = /** @class */ (function (_super) {
    tslib_1.__extends(PoleForemanWirePhaseHeightFieldJoin, _super);
    function PoleForemanWirePhaseHeightFieldJoin(field) {
        var _this = _super.call(this, field) || this;
        _this.type = 'PoleForemanWirePhaseHeightJoin';
        return _this;
    }
    PoleForemanWirePhaseHeightFieldJoin.accepts = function (field) {
        return WIRE_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
    };
    PoleForemanWirePhaseHeightFieldJoin.prototype.joins = function (other) {
        var joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        var framingType = this.getFieldValue(this.wire, 'framingType');
        if (this.isDeadend(framingType)) {
            return false;
        }
        if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
            return false;
        }
        return this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.wire, other.wire, 'framingType') &&
            this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
            this.fieldsEqual(this.wire, other.wire, 'wireQuantity');
    };
    return PoleForemanWirePhaseHeightFieldJoin;
}(field_join_ikecalc_1.IkeCalcFieldJoin));
exports.PoleForemanWirePhaseHeightFieldJoin = PoleForemanWirePhaseHeightFieldJoin;
//# sourceMappingURL=field.join.poleforeman.wire.js.map